export default __webpack_public_path__ + "static/linguaclub-banner-23461fab7249661a3f619f1a30b31ec2.svg";